import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { convertObjectKeysToSnakeCase } from "../../Shared/ConvertObjectKeysToSnakeCase";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const createSetupIntent = ({ onResponse, onError, body }) => {
  fetch(
    "/api/stripe/setup_intent",
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getPaymentMethod = ({ onResponse, onError }) => {
  fetch(
    "/api/stripe/payment_method",
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const removePaymentMethod = ({ onResponse, onError, body }) => {
  fetch(
    "/api/stripe/payment_method",
    {
      method: HTTPRequestMethods.DELETE,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const updateBillingAddress = ({ onResponse, onError, body }) => {
  fetch(
    "/api/stripe/billing_address",
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getSubscription = ({ onResponse, onError }) => {
  fetch(
    "/api/stripe/subscription",
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const createSubscription = ({ onResponse, onError, body }) => {
  fetch(
    "/api/stripe/subscription",
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const cancelSubscription = ({ onResponse, onError, body }) => {
  fetch(
    "/api/stripe/subscription",
    {
      method: HTTPRequestMethods.DELETE,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const closeCurrentUserAccount = ({ onResponse, onError, body }) => {
  fetch(
    "/api/accounts/close",
    {
      method: HTTPRequestMethods.DELETE,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const createAndSendPasswordResetToken = ({ onResponse, onError, body }) => {
  fetch(
    "/api/accounts/generate_and_send_password_reset_token",
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const createSession = ({ onResponse, onError, body }) => {
  fetch(
    "/api/sessions",
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const deleteSession = ({ onResponse, onError, body }) => {
  fetch(
    "/api/sessions/end",
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const getCurrentUserAccount = ({ onResponse, onError }) => {
  fetch(
    `/api/accounts`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const openNewAccount = ({ onResponse, onError, body }) => {
  fetch(
    "/api/accounts",
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const resetCurrentAccountPassword = ({ onResponse, onError, body }) => {
  fetch(
    "/api/accounts/reset_password",
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const updateCurrentAccountPassword = ({ onResponse, onError, body }) => {
  fetch(
    "/api/accounts/update_password",
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const updateCurrentAccountPrimaryEmail = ({ onResponse, onError, body }) => {
  fetch(
    "/api/accounts/update_primary_email",
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
